/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'

class EditVersionFile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      info: {}
    }
  }

  componentDidMount() {}

  EditFileVersion() {
    let {id} = this.props.match.params
    var fileVal = document.getElementById('file').value
    var fileElement = document.getElementById('file')

    var formData = new FormData()
    var fileError = false
    var formError = false

    if (fileVal == '') {
      fileError = true
      formError = true
      message.error('فایل را مشخص کنید')
    } else if (fileVal.substring(fileVal.length - 4, fileVal.length) !== '.apk') {
      fileError = true
      formError = true
      message.error('فرمت فایل باید apk. باشد')
    } else {
      if (!fileError) {
        this.setState({error: ''})
      }
    }

    if (!formError) {
      formData.append('file', fileElement.files[0])
      formData.append('id', id)

      http.post(`${BASE_MANAGE.BASE_MANAGE_SYSTEM_EDIT_APPVERSION_FILE}`, formData, {}).then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          message.success('ورژن ویرایش شد')
          setInterval(() => {
            window.location.assign('/version')
          }, 2000)
        } else {
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
    }
  }

  submit(e) {
    e.preventDefault()
  }

  render() {
    return (
      <div className="rtl">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>
              <Link to={'/version'}>نسخه های اپلیکیشن</Link>
            </li>
            <li>ویرایش فایل ورژن</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ویرایش فایل ورژن</p>
            </div>
            <div className="formComponent">
              <label>
                فایل <span className="requireFiled">*</span>
              </label>
              <input type="file" min="1" id="file" name="file" className="form-control" />

              <button className="btn btn-primary btn-block" onClick={this.EditFileVersion.bind(this)}>
                ویرایش
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default EditVersionFile
